export class NumberHelper {

    // Returns a number as a string formatted for culture with commas.
    static formatWithCommas(value: number) : string {
        let formatter = new Intl.NumberFormat();
        return formatter.format(value);
    }

    // Gets a formatted length of time from ticks.
    static getTimeLengthFromTicks(ticks: number, shortVersion: boolean = false) : string {
        let totalSeconds = ticks / 10000 / 1000;
        let seconds = Math.floor(totalSeconds % 60);
        let minutes = Math.floor(totalSeconds / 60 % 60);
        let hours = Math.floor(totalSeconds / 60 / 60 % 24);
        let days = Math.floor(totalSeconds / 60 / 60 / 24);

        let result = "";
        if (shortVersion) {
            result += days > 0 ? `${days}.` : ""
            result += totalSeconds > (60 * 60) ? `${hours.toLocaleString('en', {minimumIntegerDigits:2})}:` : ""
            result += totalSeconds > 60 ? `${minutes.toLocaleString('en', {minimumIntegerDigits:2})}:` : ""
            result += `${seconds.toLocaleString('en', {minimumIntegerDigits:2})}`
        }
        else {
            result += days > 0 ? `${days} days, ` : ""
            result += totalSeconds > (60 * 60) ? `${hours} hours, ` : ""
            result += totalSeconds > 60 ? `${minutes} minutes, ` : ""
            result += `${seconds} seconds`
        }

        return result;
    }
}